import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DatadogService } from '../../shared/services/datadog.service';
import { buildNewsFeed } from '../news.data';
import { NewsItem } from '../news.model';

@Component({
  standalone: false,
  selector: 'app-news-index',
  templateUrl: './news-index.component.html',
  styleUrls: ['./news-index.component.scss'],
})
export class NewsIndexComponent implements OnInit {
  private readonly titleService = inject(Title);
  private readonly datadogService = inject(DatadogService);

  private readonly feed = signal<NewsItem[]>(sortNewsFeed(buildNewsFeed()));

  readonly featured = computed(() => this.feed().find(item => item.featured) ?? null);
  readonly entries = computed(() => this.feed().filter(item => !item.featured));

  ngOnInit(): void {
    this.titleService.setTitle('News');
  }

  onNewsLinkClick(item: NewsItem): void {
    this.datadogService.trackAction('news_item_link_clicked', { id: item.id, url: item.link?.url });
  }
}

/** Featured entries are pinned to the top; everything else reads newest first. */
export function sortNewsFeed(items: NewsItem[]): NewsItem[] {
  return [...items].sort((a, b) => {
    if (!!a.featured !== !!b.featured) {
      return a.featured ? -1 : 1;
    }

    return b.publishedOn.localeCompare(a.publishedOn);
  });
}
